import {
    FETCH_PRACTICE_MACHINES_START, FETCH_PRACTICE_USERS_START, FETCH_ROSTER_START,
    FETCH_PRACTICE_MACHINES_SUCCESS, FETCH_PRACTICE_USERS_SUCCESS, FETCH_ROSTER_SUCCESS,
    FETCH_ROSTER_ERROR,
    FETCH_PRACTICE_MACHINES_ERROR,
    FETCH_PRACTICE_USERS_ERROR,
    DELETE_ROSTER_EVENT_SUCCESS,
    ADD_UPDATE_ROSTER_EVENT_SUCCESS,
    ADD_UPDATE_ROSTER_EVENT_START,
    DELETE_ROSTER_EVENT_START,
    ADD_UPDATE_ROSTER_EVENT_ERROR,
    DELETE_ROSTER_EVENT_ERROR,
} from '../actions/rosterAction';

const INIT_STATE = {
    loading: false,
    submitting: false,
    machines: [],
    users: [],
    events: [],
};

const rosterReducer = (state = INIT_STATE, action) => {
    let newEvents;
    switch (action.type) {
        case FETCH_PRACTICE_MACHINES_START:
        case FETCH_PRACTICE_USERS_START:
        case FETCH_ROSTER_START: {
            return { ...state, loading: true };
        }
        case FETCH_PRACTICE_MACHINES_SUCCESS: {
            return { ...state, loading: false, machines: action.machines };
        }
        case FETCH_PRACTICE_USERS_SUCCESS: {
            return { ...state, loading: false, users: action.users };
        }
        case FETCH_ROSTER_SUCCESS: {
            return { ...state, loading: false, events: action.events };
        }
        case FETCH_PRACTICE_MACHINES_ERROR:
        case FETCH_PRACTICE_USERS_ERROR:
        case FETCH_ROSTER_ERROR: {
            return { ...state, loading: false };
        }
        case ADD_UPDATE_ROSTER_EVENT_START:
        case DELETE_ROSTER_EVENT_START: {
            return { ...state, submitting: true };
        }
        case ADD_UPDATE_ROSTER_EVENT_SUCCESS: {
            newEvents = [...state.events];
            const index = newEvents.findIndex(evt => evt.timeslotId === action.event.timeslotId);
            if (index > -1) {
                newEvents.splice(index, 1, { ...newEvents[index], ...action.event });
            } else {
                newEvents.push(action.event);
            }
            return { ...state, submitting: false, events: [...newEvents] };
        }
        case DELETE_ROSTER_EVENT_SUCCESS: {
            newEvents = [...state.events];
            const index = newEvents.findIndex(evt => evt.timeslotId === action.timeslotId);
            if (index > -1) {
                newEvents.splice(index, 1);
            }
            return { ...state, submitting: false, events: [...newEvents] };
        }
        case ADD_UPDATE_ROSTER_EVENT_ERROR:
        case DELETE_ROSTER_EVENT_ERROR: {
            return { ...state, submitting: false };
        }
        default:
            return state;
    }
}

export default rosterReducer;